const styles = {
  headerRow: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'flex-start', md: 'center' },
    justifyContent: 'space-between',
    gap: 2,
  },
  pageTitle: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '1.75rem', sm: '2.375rem' },
    lineHeight: '100%',
    color: '#5236AB',
  },
fabButton: {
    width: 48,
    height: 48,
    minWidth: 48,
    minHeight: 48,
    borderRadius: '50%',
    backgroundColor: '#5236AB',
    color: '#F0F0F0',
    border: '1px solid #5236AB',
    padding: 0,
    '&:hover': { backgroundColor: '#E0E0E0' },
  },
};

export default styles;
